import { makeStyles } from "tss-react/mui";

export const usePlatformIconStyle = makeStyles()(() => ({
  pomPlatformDetailsIcon: {
    height: 30,
    width: 54,
  },
}));
